import { AnyAction } from 'redux';
import { MenuItemActionType } from '.';
import { MenuItemType } from '../model/menuItems';

export interface ChangedAction extends AnyAction {
    type: MenuItemActionType.Changed;
    current: MenuItemType;
}

export const changed = (current: MenuItemType): ChangedAction => ({
    type: MenuItemActionType.Changed,
    current
});

export type MenuItemAction =
    | ChangedAction;



// WEBPACK FOOTER //
// ./src/actions/menuItemActions.ts